import { createStyles } from '@mui/styles';

export const SignatureRequirementStyles = () =>
  createStyles({
    searchField: {
      minWidth: '300px',
      marginRight: '8px',
    },
    searchIcon: {
      color: '#666',
    },
    textFieldEndAdornment: {
      cursor: 'pointer',
    },
    modalButton: {
      marginLeft: '8px',
    },
    rightSideContainer: {
      paddingTop: '28px',
    },
  });
